<h1 mat-dialog-title>{{ 'Delete Static Route' | translate }}</h1>
<div mat-dialog-content>
  <p class="message" [innerHTML]="deleteMessage | translate: { name: route.destination }"></p>
</div>
<ix-form-actions mat-dialog-actions class="form-actions">
  <button mat-button ixTest="cancel" [matDialogClose]="false">{{ 'Cancel' | translate }}</button>
  <button
    *ixRequiresRoles="requiredRoles"
    mat-button
    color="primary"
    ixTest="delete"
    (click)="onDelete()"
  >
    {{ 'Delete' | translate }}
  </button>
</ix-form-actions>
